<template>
  <div class="Brand">
    <div class="Brand_w">
      <div class="Brand_left">
        <div class="Brand_tit">Brand Kit</div>
        <div class="Brand_tit1">
          Welcome to the DO Network Brand and<br />
          Marketing Guidelines Page!
        </div>
        <div class="Brand_tit2">
          When promoting DO Network in advertisements,<br />
          articles, websites, or printed materials, please<br />
          strictly adhere to the following guidelines to<br />
          ensure consistent messaging and a<br />
          professional brand image.
        </div>
        <div class="Brand_line"></div>
        <div class="Brand_down">
          <!-- <div class="Brand_btn">
            <img src="../../../assets/m/brand/1.png" />
            <div class="Brand_tita">Brand guidelines</div>
          </div> -->
          <a
            href="https://fastcdn.donetwork.io/official/Assets_Logo.rar"
            target="_blank"
          >
            <div class="Brand_btn1">
              <img src="../../../assets/m/brand/2.png" />
              <div class="Brand_tita">Asset downloads</div>
            </div></a
          >
        </div>
        <div class="Brand_line1"></div>
        <div class="Brand_tit3">DO Network Brand</div>
        <div class="Brandbox">
          <div class="Brandtit">Logotype</div>
          <img src="../../../assets/pc/brand/1.png" class="img1" />
          <div class="Brandtit1">
            The DO Network brand logo features a clean<br />
            and modern design, with the icon based on a<br />
            rounded rectangle containing a gradient blue<br />
            "D" element. This highlights the brand's initial<br />
            and enhances recognition. The typography <br />uses a sans-serif
            style paired with a blue<br />
            theme, conveying a sense of technology and<br />
            professionalism. The overall style is fresh and<br />
            contemporary.
          </div>
        </div>
        <div class="Brandbox">
          <div class="Brandtit">Clearspace</div>

          <div class="Brandtit1">
            To ensure the clarity and recognizability of <br />the brand logo,
            please maintain sufficient<br />
            white space around it to prevent interference<br />
            from other patterns, images, or page edges.<br />
            Below are the minimum spacing<br />
            requirements for the corporate logo and<br />
            wordmark.
          </div>
          <img src="../../../assets/pc/brand/6.png" class="img2" />
          <div class="imgbox">
            <img src="../../../assets/pc/brand/7.png" class="img3" />
            <img src="../../../assets/pc/brand/8.png" class="img4" />
          </div>
        </div>
        <div class="Brandbox">
          <div class="Brandtitlogo">Logo Usage Guidelines</div>

          <div class="Brandtitlogo1">
            The following are actions to avoid when using<br />
            the DO Network brand logo
          </div>

          <div class="imgbox1">
            <div class="imgboxli">
              <img src="../../../assets/pc/brand/9.png" class="img5" />
              <div class="liimg">
                <img src="../../../assets/pc/brand/15.png" class="img6" />
                <div class="litit">Don’t add shadows behind the logo</div>
              </div>
            </div>
            <div class="imgboxli">
              <img src="../../../assets/pc/brand/10.png" class="img5" />
              <div class="liimg">
                <img src="../../../assets/pc/brand/15.png" class="img6" />
                <div class="litit">Don’t add outlines to the logo</div>
              </div>
            </div>
            <div class="imgboxli">
              <img src="../../../assets/pc/brand/11.png" class="img5" />
              <div class="liimg">
                <img src="../../../assets/pc/brand/15.png" class="img6" />
                <div class="litit">Don’t stretch the logo</div>
              </div>
            </div>
            <div class="imgboxli">
              <img src="../../../assets/pc/brand/12.png" class="img5" />
              <div class="liimg">
                <img src="../../../assets/pc/brand/15.png" class="img6" />
                <div class="litit">Don’t apply logo in low resolution</div>
              </div>
            </div>
            <div class="imgboxli">
              <img src="../../../assets/pc/brand/13.png" class="img5" />
              <div class="liimg">
                <img src="../../../assets/pc/brand/15.png" class="img6" />
                <div class="litit">Don’t use logo as a frame for imagery</div>
              </div>
            </div>
            <div class="imgboxli">
              <img src="../../../assets/pc/brand/14.png" class="img5" />
              <div class="liimg">
                <img src="../../../assets/pc/brand/15.png" class="img6" />
                <div class="litit">Don’t place on low contrast colors</div>
              </div>
            </div>
          </div>
        </div>
        <div class="Brandbox">
          <div class="Brandtit">Colors</div>
          <div class="colorbox">
            <div class="colorli">
              <div class="colorlis"></div>
              <div class="colorlix">
                <div class="colorcon"></div>
                <div class="colorcon1"></div>
                <div class="colortit">DO Network Gradient Colors</div>
              </div>
            </div>
            <div class="colorli1">
              <div class="colorli1l">
                <div class="colortit">#5991FD</div>
              </div>
              <div class="colorli1r">
                <div class="colortit">#2F52CE</div>
              </div>
            </div>
            <div class="colorli2">
              <div class="colorli1l">
                <div class="colortita">#4573E7</div>
              </div>
              <div class="colorbtm">
                <div class="colorcon"></div>
                <div class="colortit">Font Color</div>
              </div>
            </div>
          </div>
        </div>
        <div class="Brandbox1">
          <div class="assets">Assets</div>
          <a
            href="https://fastcdn.donetwork.io/official/Assets_Logo.rar"
            target="_blank"
            ><div class="assetsbox">
              <img src="../../../assets/pc/brand/16.png" />
              <div class="assettit">Download Assets</div>
            </div></a
          >
          <div class="asset1">Main Logotype</div>
          <div class="assetall">
            <img src="../../../assets/pc/brand/17.png" class="imgasset" />
            <div class="assetbtn">
              <a href="https://fastcdn.donetwork.io/official/Logo.rar">
                <div>PNG</div></a
              >
              <a href="https://fastcdn.donetwork.io/official/Logo_SVG.rar"
                ><div>SVG</div></a
              >
            </div>
          </div>
          <div class="asset1">LOGO Mark</div>
          <div class="assetall">
            <img src="../../../assets/pc/brand/18.png" class="imgasset" />
            <div class="assetbtn">
              <a href="https://fastcdn.donetwork.io/official/DO_Logo.rar"
                ><div>PNG</div></a
              >
              <a href="https://fastcdn.donetwork.io/official/DO_Logo_SVG.rar">
                <div>SVG</div></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="less">
.w1352 {
  width: 1200px;
  margin: 0 auto;
}
.w1300 {
  width: 67%;
  margin: 0 auto;
}
</style>
<style lang="less" scoped>
.Brand {
  background: #fff;
  margin-top: 120px;
  .Brand_w {
    width: 650px;
    margin: 0 auto;
    display: flex;
    .Brand_left {
      width: 650px;
      .Brand_tit {
        width: 648px;
        height: 83px;
        font-family: Poppins, Poppins;
        font-weight: 900;
        font-size: 64px;
        color: #000000;
        line-height: 83px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-top: 120px;
      }
      .Brand_tit1 {
        width: 647px;
        height: 107px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 32px;
        color: #000000;
        line-height: 53px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-top: 25px;
      }
      .Brand_tit2 {
        width: 648px;
        height: 215px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 27px;
        color: #61666b;
        line-height: 43px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-top: 20px;
      }
      .Brand_line {
        height: 3px;
        width: 650px;
        background: #f2f5f9;
        border-radius: 0px 0px 0px 0px;
        margin-top: 67px;
      }
      .Brand_line1 {
        height: 3px;
        width: 650px;
        background: #f2f5f9;
        border-radius: 0px 0px 0px 0px;
        margin-top: 29px;
      }
      .Brand_down {
        display: flex;
        justify-content: center;
        margin-top: 29px;
        .Brand_btn,
        .Brand_btn1 {
          width: 309px;
          height: 62px;

          border-radius: 8px 8px 8px 8px;
          display: flex;

          img {
            width: 39px;
            height: 39px;
            margin-left: 35px;
            margin-top: 12px;
            margin-right: 10px;
          }
          .Brand_tita {
            font-family: Poppins, Poppins;
            font-weight: 600;
            font-size: 22px;

            line-height: 62px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }
        .Brand_btn {
          background: #4573e7;
          display: flex;
          .Brand_tita {
            color: #fff;
            line-height: 62px;
          }
        }
        .Brand_btn1 {
          background: #f2f5f9;
          .Brand_tita {
            color: #4573e7;
            line-height: 62px;
          }
        }
      }
      .Brand_tit3 {
        width: 507px;
        margin: 0 auto;
        height: 61px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 40px;
        color: #000000;
        line-height: 60px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-top: 80px;
      }
      .Brandbox {
        margin-top: 60px;
        .Brandtit {
          width: 151px;
          height: 55px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 32px;
          color: #1a1a2c;
          line-height: 54px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin: 0 auto;
        }
        .img1 {
          width: 476px;
          height: 75px;
          margin-top: 23px;
          margin-left: 91px;
        }
        .Brandtit1 {
          width: 650px;
          height: 387px;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 28px;
          color: #61666b;
          line-height: 43px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin-top: 40px;
        }
        .img2 {
          width: 650px;
          height: 199px;
          margin-top: 32px;
        }
        .imgbox {
          display: flex;
          margin-top: 40px;
          .img3 {
            width: 305px;
            height: 305px;
            margin-right: 40px;
          }
          .img4 {
            width: 305px;
            height: 305px;
          }
        }
        .imgbox1 {
          margin-top: 27px;

          .imgboxli {
            margin-bottom: 40px;
            .img5 {
              width: 650px;
              height: 238px;
            }
            .liimg {
              display: flex;
              margin-top: 21px;
              .img6 {
                width: 32px;
                height: 32px;
                margin-top: 6px;
                margin-right: 13px;
              }
              .litit {
                height: 43px;
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 28px;
                color: #1a1a2c;
                line-height: 43px;
                text-align: left;
                font-style: normal;
                text-transform: none;
              }
            }
          }
        }
        .colorbox {
          // display: flex;
          // justify-content: space-between;
          .colorli {
            .colorlis {
              width: 650px;
              height: 197px;
              background: linear-gradient(91deg, #5991fd 0%, #2f52ce 100%);
              border-radius: 10px 10px 10px 10px;
              margin-top: 31px;
            }
            .colorlix {
              display: flex;
              margin-top: 27px;
              .colorcon {
                width: 32px;
                height: 32px;
                background: #5991fd;
                border-radius: 50%;
              }
              .colorcon1 {
                width: 32px;
                height: 32px;
                background: #2f52ce;
                border: 3px solid #ffffff;
                border-radius: 50%;
                margin-left: -10px;
              }
              .colortit {
                width: 393px;

                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 28px;

                text-align: left;
                font-style: normal;
                text-transform: none;
                background: linear-gradient(90deg, #5991fd, #2f52ce);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                margin-left: 8px;
              }
            }
          }
          .colorli1 {
            display: flex;
            justify-content: space-between;
            margin-top: 53px;
            .colorli1l {
              width: 305px;
              height: 198px;
              background: #5991fd;
              border-radius: 10px 10px 10px 10px;
              .colortit {
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 28px;
                color: #ffffff;
                line-height: 42px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 143px;
                margin-left: 16px;
              }
            }
            .colorli1r {
              width: 305px;
              height: 198px;
              background: #2f52ce;
              border-radius: 10px 10px 10px 10px;
              .colortit {
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 28px;
                color: #ffffff;
                line-height: 42px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 143px;
                margin-left: 16px;
              }
            }
          }
          .colorli2 {
            .colorli1l {
              height: 198px;
              width: 650px;
              background: #4573e7;
              border-radius: 10px 10px 10px 10px;
              .colortita {
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 28px;
                color: #ffffff;
                line-height: 42px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 40px;
                padding-top: 143px;
                margin-left: 16px;
              }
            }
            .colorbtm {
              display: flex;
              margin-top: 23px;
              .colorcon {
                width: 32px;
                height: 32px;
                background: #4573e7;
                border-radius: 50%;
                margin-top: 4px;
              }
              .colortit {
                height: 42px;
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 28px;
                color: #4573e7;
                line-height: 42px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-left: 8px;
              }
            }
          }
        }
        .Brandtitlogo {
          // width: 368px;
          height: 55px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 32px;
          color: #1a1a2c;
          line-height: 54px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin-top: 93px;
        }
        .Brandtitlogo1 {
          width: 650px;
          height: 86px;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 28px;
          color: #61666b;
          line-height: 43px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin-top: 27px;
        }
      }
      .Brandbox1 {
        margin-top: 115px;
        padding-bottom: 160px;
        .assets {
          width: 648px;
          height: 83px;
          font-family: Poppins, Poppins;
          font-weight: 900;
          font-size: 64px;
          color: #000000;
          line-height: 83px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .assetsbox {
          display: flex;
          width: 391px;
          height: 80px;
          background: #4573e7;
          border-radius: 11px 11px 11px 11px;
          margin-top: 45px;
          margin-left: 129px;
          img {
            width: 43px;
            height: 43px;
            margin-left: 43px;
            margin-top: 19px;
            margin-right: 14px;
          }
          .assettit {
            font-family: Poppins, Poppins;
            font-weight: 600;
            font-size: 28px;
            color: #ffffff;
            line-height: 80px;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }
        }
        .asset1 {
          width: 257px;
          height: 55px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 32px;
          color: #1a1a2c;
          line-height: 54px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin-top: 53px;
          margin-bottom: 20px;
          text-align: left;
        }
        .assetall {
          display: flex;
          flex-direction: column;
          .imgasset {
            width: 650px;
            height: 189px;
            background: #f5f7fd;
            border-radius: 11px 11px 11px 11px;
          }
          .assetbtn {
            margin-top: 40px;
            display: flex;
            div {
              width: 210px;
              height: 80px;
              line-height: 80px;
              text-align: center;
              background: #e1eaff;
              border-radius: 149px 149px 149px 149px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 32px;
              color: #4573e7;
              margin-right: 33px;
            }
          }
        }
      }
    }
  }
}
</style>
